export default "__VITE_ASSET__ncmNY02S__"